import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col, Tab, Tabs, Form, Modal } from "react-bootstrap";
import {
  LegendFieldComponent,
  LegendTextareaComponent,
  IconFieldComponent,
} from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import { FileUploadComponent } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import { API_URL, getApiMessage } from "../../constant/constant";
import axios from "axios";
import Placeholder from "./placeholder/placeholder.webp";
import HeaderLayout from "../../layouts/HeaderLayout";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function AdminProfilePage() {
  const { t, currentLanguage } = useContext(TranslatorContext);
  const langCode = currentLanguage?.code || "en";

  const [adminDetails, setadminDetails] = useState({});
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [showImagePopup, setShowImagePopup] = useState(false);

  const [modalShow, setModalShow] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [mobile, setmobile] = useState("");
  const [preview, setpreview] = useState(Placeholder);

  const [OldPassword, setOldPassword] = useState("");
  const [NewPassword, setNewPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");

  const [OldPasswordError, setOldPasswordError] = useState("");
  const [NewPasswordError, setNewPasswordError] = useState("");
  const [ConfirmPasswordError, setConfirmPasswordError] = useState("");

  const [nameError, setnameError] = useState("");
  const [emailError, setemailError] = useState("");
  const [mobileError, setmobileError] = useState("");
  const [saveProfileLoading, setSaveProfileLoading] = useState(false);
  const [savePasswordLoading, setSavePasswordLoading] = useState(false);
  const [updateError, setUpdateError] = useState("");

  // pop up message
  const [Msg, setMsg] = useState("");

  const fetchAdminDetails = () => {
    const user_type = localStorage.getItem("user_type");
    axios
      .post(API_URL + "/get_admin_details", { user_type })
      .then((response) => {
        const adminData = response.data.admin_arr[0];
        setadminDetails(adminData);
        setname(adminData.name || "");
        setemail(adminData.email || "");
        const rawMobile =
          adminData.mobile != null && adminData.mobile !== undefined
            ? String(adminData.mobile).replace(/^\+/, "").trim()
            : "";
        setmobile(rawMobile === "" ? "965" : rawMobile);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const handleFileUpload = (file) => {
    setSelectedImage(file);
    setpreview(URL.createObjectURL(file));
  };

  const setFieldErrorByKey = (key, msg) => {
    if (!msg) return;
    switch (String(key || "").toLowerCase()) {
      case "name":
        setnameError(msg);
        break;
      case "email":
        setemailError(msg);
        break;
      case "mobile":
        setmobileError(msg);
        break;
      case "user_type":
      case "data":
      default:
        setUpdateError(msg);
    }
  };

  const handleUpdate = () => {
    setUpdateError("");
    setnameError("");
    setemailError("");
    setmobileError("");
    let hasError = false;
    if (!name || name == "" || name == null) {
      setnameError(t("enter_your_name"));
      hasError = true;
    }
    if (!email || email == "" || email == null) {
      setemailError(t("enter_your_email"));
      hasError = true;
    }
    const mobileStr = (mobile || "").trim();
    const mobileDigits = mobileStr.replace(/\D/g, "");
    if (!mobile || mobile === "" || mobile == null) {
      setmobileError(t("enter_mobile"));
      hasError = true;
    } else if (mobileDigits.length < 8 || mobileDigits.length > 15) {
      setmobileError(t("invalid_mobile_length"));
      hasError = true;
    } else if (!/^\+?[\d\s-]+$/.test(mobileStr)) {
      setmobileError(t("invalid_mobile_format"));
      hasError = true;
    } else {
      setmobileError("");
    }

    if (hasError) {
      return;
    }
    const user_type = localStorage.getItem("user_type");
    if (!user_type) {
      setUpdateError(t("session_expired") || "Please log in again.");
      return;
    }
    const formData = new FormData();
    formData.append("user_type", user_type);
    formData.append("name", name || "");
    formData.append("email", email || "");
    formData.append("mobile", mobile || "");

    if (selectedImage) {
      formData.append("image", selectedImage);
    }

    setSaveProfileLoading(true);
    axios
      .post(API_URL + "/edit_admin_details", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          setUpdateError("");
          setMsg(
            getApiMessage(response.data, langCode) || t("profile_updated"),
          );
          setModalShow(true);
          setTimeout(() => {
            setModalShow(false);
            fetchAdminDetails();
          }, 1000);
        } else {
          const msg =
            getApiMessage(response.data, langCode) ||
            response.data?.msg ||
            t("update_failed");
          const key = response.data?.key;
          setFieldErrorByKey(key, msg);
          if (!key) setUpdateError(msg);
        }
      })
      .catch((error) => {
        const data = error?.response?.data;
        const msg =
          getApiMessage(data, langCode) ||
          error?.message ||
          t("something_went_wrong");
        const key = data?.key;
        setFieldErrorByKey(key, msg);
        if (!key) setUpdateError(msg);
        console.error("error", error);
      })
      .finally(() => setSaveProfileLoading(false));
  };

  const handlePasswordChange = () => {
    let hasError = false;
    if (!OldPassword) {
      setOldPasswordError(t("enter_current_password"));
      hasError = true;
    }
    if (!NewPassword) {
      setNewPasswordError(t("enter_new_password"));
      hasError = true;
    }
    if (!ConfirmPassword) {
      setConfirmPasswordError(t("enter_confirm_password"));
      hasError = true;
    }

    if (hasError) {
      return;
    }

    if (NewPassword != ConfirmPassword) {
      setConfirmPasswordError(t("password_equal"));
      return;
    }
    if (NewPassword.length < 6) {
      setNewPasswordError(t("password_less"));
      return;
    }
    const user_type = localStorage.getItem("user_type");
    const formData = new FormData();
    formData.append("user_type", user_type);
    formData.append("old_password", OldPassword);
    formData.append("new_password", NewPassword);

    setSavePasswordLoading(true);
    axios
      .post(API_URL + "/change_admin_password", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (!response.data.success) {
          const msg = getApiMessage(response.data, langCode);
          setOldPasswordError(
            msg ||
              (response.data.key == "old_password"
                ? t("current_inccorect")
                : t("something_went_wrong")),
          );
          return;
        }
        setMsg(getApiMessage(response.data, langCode) || t("password_changed"));
        setModalShow(true);
        setTimeout(() => {
          setModalShow(false);
          fetchAdminDetails();
        }, 1000);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      })
      .catch((error) => {
        setOldPasswordError(
          getApiMessage(error?.response?.data, langCode) ||
            error?.message ||
            t("something_went_wrong"),
        );
        console.error("error", error);
      })
      .finally(() => setSavePasswordLoading(false));
  };

  useEffect(() => {
    fetchAdminDetails();
  }, []);

  const handleImageClick = (imageUrl) => {
    setEnlargedImage(imageUrl);
    setShowImagePopup(true);
  };

  const handleCloseImage = () => {
    setEnlargedImage(null);
    setShowImagePopup(false);
  };

  return (
    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">{t("my_account")}</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("home")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">
                    {t("users")}
                  </Link>
                </li>
                <li className="mc-breadcrumb-item">{t("my_account")}</li>
              </ul>
            </div>
          </div>
        </Col>
        <Col xl={12}>
          <div className="mc-card">
            <Tabs defaultActiveKey="profile" id="mc" className="mc-tabs">
              <Tab
                eventKey="profile"
                title={t("edit_profile")}
                className="mc-tabpane profile"
              >
                <div className="mc-tab-card">
                  <h6 className="mc-tab-card-title">{t("profile")}</h6>
                  <Row>
                    <Col xl={4}>
                      <div className="mc-user-avatar-upload">
                        {adminDetails && (
                          <img
                            src={
                              adminDetails.image
                                ? `${adminDetails.image}`
                                : `image-1720095670109.png`
                            }
                            alt="Profile"
                            style={{
                              width: "15rem",
                              height: "15rem",
                              cursor: "pointer",
                              objectFit: "cover",
                              borderRadius: "10px",
                              marginBottom: "20px",
                            }}
                            onClick={() =>
                              handleImageClick(
                                adminDetails.image
                                  ? `${adminDetails.image}`
                                  : `image-1720095670109.png`,
                              )
                            }
                            role="button"
                            tabIndex={0}
                          />
                        )}

                        {/* Enlarged image overlay */}
                        {showImagePopup && (
                          <div
                            className="enlarged-image-overlay"
                            onClick={handleCloseImage}
                            role="button"
                            tabIndex={0}
                          >
                            <span
                              className="close-button"
                              onClick={handleCloseImage}
                              role="button"
                              tabIndex={0}
                            >
                              &times;
                            </span>
                            <img
                              src={enlargedImage}
                              alt="Enlarged Profile"
                              className="enlarged-image"
                              style={{
                                width: "30rem",
                                height: "30rem",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col xl={8}>
                      <Row>
                        <Col xl={12}>
                          <LegendFieldComponent
                            type="text"
                            title={t("fullname")}
                            value={name}
                            className="mb-2"
                            placeholder={t("enter_your_name")}
                            onChange={(e) => {
                              setname(e.target.value);
                              setnameError("");
                            }}
                          />
                          <p
                            className="mb-3"
                            style={{ color: "red", fontSize: "13px" }}
                          >
                            {nameError}
                          </p>
                        </Col>
                        <Col xl={12}>
                          <LegendFieldComponent
                            type="text"
                            title={t("email")}
                            value={email}
                            placeholder={t("enter_your_email")}
                            className="mb-2"
                            onChange={(e) => {
                              setemail(e.target.value);
                              setemailError("");
                            }}
                          />
                          <p
                            className="mb-3"
                            style={{ color: "red", fontSize: "13px" }}
                          >
                            {emailError}
                          </p>
                        </Col>
                        <Col xl={12}>
                          <label className="form-label mb-1">
                            {t("mobile")}
                          </label>
                          <PhoneInput
                            country="kw"
                            preferredCountries={["kw"]}
                            value={mobile}
                            onChange={(value) => {
                              setmobile(value);
                              setmobileError("");
                            }}
                            inputStyle={{
                              width: "100%",
                              paddingLeft: "48px",
                              borderRadius: "4px",
                              border: mobileError
                                ? "1px solid #dc3545"
                                : "1px solid #ced4da",
                              height: "38px",
                            }}
                            placeholder="+965 12345678"
                            countryCodeEditable={false}
                          />
                          <p
                            className="mb-3"
                            style={{ color: "red", fontSize: "13px" }}
                          >
                            {mobileError}
                          </p>
                        </Col>

                        <Col xl={12}>
                          <div className="row">
                            <div className="col-lg-2">
                              <div
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  margin: "auto",
                                  marginBottom: "10px",
                                }}
                              >
                                <img
                                  src={preview}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "50%",
                                  }}
                                ></img>
                              </div>
                            </div>
                          </div>
                          <FileUploadComponent
                            icon="cloud_upload"
                            text={t("upload")}
                            onFileUpload={handleFileUpload}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
                {updateError && (
                  <p
                    className="mb-2"
                    style={{ color: "red", fontSize: "13px" }}
                  >
                    {updateError}
                  </p>
                )}
                <ButtonComponent
                  className="mc-btn primary"
                  icon="verified"
                  onClick={handleUpdate}
                  text={
                    saveProfileLoading
                      ? t("loading") || "Loading..."
                      : t("save_changes")
                  }
                  disabled={saveProfileLoading}
                />
              </Tab>

              <Tab
                eventKey="password"
                title={t("change_password")}
                className="mc-tabpane password"
              >
                <div className="mc-tab-card">
                  {/* <h6 className="mc-tab-card-title">{t('generate_password')}</h6> */}
                  <Row>
                    <Col xs={12} md={12}>
                      <IconFieldComponent
                        icon="lock"
                        type="password"
                        placeholder={t("current_password")}
                        value={OldPassword}
                        onChange={(e) => {
                          setOldPassword(e.target.value);
                          setOldPasswordError("");
                        }}
                        classes="w-100 h-lg mb-2"
                        passwordVisible
                      />
                      <p
                        className="mb-3"
                        style={{ color: "red", fontSize: "13px" }}
                      >
                        {OldPasswordError}
                      </p>
                    </Col>

                    <Col xs={12} md={6}>
                      <IconFieldComponent
                        icon="lock"
                        type="password"
                        placeholder={t("new_password")}
                        value={NewPassword}
                        onChange={(e) => {
                          setNewPassword(e.target.value);
                          setNewPasswordError("");
                          setConfirmPasswordError("");
                        }}
                        setNew
                        classes="w-100 h-lg mb-2"
                        passwordVisible
                      />
                      <p
                        className="mb-3"
                        style={{ color: "red", fontSize: "13px" }}
                      >
                        {NewPasswordError}
                      </p>
                    </Col>

                    <Col xs={12} md={6}>
                      <IconFieldComponent
                        icon="lock"
                        type="password"
                        placeholder={t("confirm_password")}
                        value={ConfirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          setConfirmPasswordError("");
                        }}
                        classes="w-100 h-lg mb-2"
                        passwordVisible
                      />{" "}
                      <p
                        className="mb-3"
                        style={{ color: "red", fontSize: "13px" }}
                      >
                        {ConfirmPasswordError}
                      </p>
                    </Col>
                  </Row>
                </div>
                <ButtonComponent
                  className="mc-btn primary"
                  icon="verified"
                  onClick={handlePasswordChange}
                  text={
                    savePasswordLoading
                      ? t("loading") || "Loading..."
                      : t("save_changes")
                  }
                  disabled={savePasswordLoading}
                />
              </Tab>
            </Tabs>
          </div>
        </Col>
      </Row>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="w-100 text-center">
            Update
            <hr
              className="my-2"
              style={{ borderTop: "2px solid #007bff", width: "100%" }}
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="lead mb-4">{Msg}</p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center"></Modal.Footer>
      </Modal>

      <HeaderLayout image={adminDetails.image} />
    </PageLayout>
  );
}
